<div class="general-wrapper" [ngClass]="{'is-sidebar-open': sidebar.isSideBarOpen}">
  <app-header></app-header>

  <router-outlet></router-outlet>

   <div class="guide-info-container">
    <div class="guide-info-btn" (click)="showInfo = !showInfo">
      <i>?</i>Contact Us
    </div>
    <div class="guide-info" *ngIf="showInfo">
      <div class="guide-header">Contact Us <i (click)="showInfo = !showInfo"></i></div>
      <div class="guide-container">
        <ul class="guide-list">
          <li *ngFor="let item of helpMaterialsConfigurations">
            <p>
              <a *ngIf="item?.DocumentLink" href="{{getUrl(item?.DocumentLink)}}" target="_blank">{{item?.Title}}</a>
              <!--<i class="icon icon-play pointer" *ngIf="item?.VideoLink" (click)="viewVideo(getUrl(item?.VideoLink))"></i>--></p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
<div class="overlay" [ngClass]="{'visible': isOverlayVisible }"  (click)="closeOverlay()">
  <video *ngIf="showVideo" controls autoplay>
    <source src="{{actualVideoUrl}}" type="video/mp4">
  </video>
</div>
